import LocationSet from  './location-set';
import Venue from '../models/venue';

export default LocationSet.extend( {
	model: Venue,
} );
